import { required, sameAs, requiredIf } from 'vuelidate/lib/validators'

const isValidEmail = (value) => {
    // eslint-disable-next-line no-control-regex
    const emailRegExp = /(?:[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[A-Za-z0-9-]*[A-Za-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    return !!emailRegExp.test(value)
}

export default {
    validations: {
        user: {
            email: {
                required,
                isValidEmail,
            },
            password: {
                required,
            },
            passwordConfirm: {
                required,
                sameAsPassword: sameAs('password'),
            },
            first_name: {
                required,
            },
            tax_number: {
                required,
            },
            street: {
                required,
            },
            city: {
                required,
            },
            state: {
                required,
            },
            country_id: {
                required,
            },
        },

        company: {
            title: {
                required,
            },
            tax_number: {
                required,
            },
            phone: {
                required,
            },
            email: {
                required,
                isValidEmail,
            },
            street: {
                required,
            },
            city: {
                required,
            },
            state: {
                required,
            },
            country_id: {
                required,
            },
        },

        selectedCurrency: {
            required,
        },
    },

    computed: {
        emailErrors() {
            let errors = ''

            if (!this.$v.user.email.$dirty) {
                return errors
            }

            if (!this.$v.user.email.required)
                errors = errors.concat(this.$t('validations.email_is_required'))

            if (!this.$v.user.email.isValidEmail)
                errors = errors.concat(
                    this.$t('validations.email_has_invalid_format')
                )

            return errors
        },

        phoneErrors() {
            let errors = ''

            if (!this.$v.user.phone.$dirty) {
                return errors
            }

            if (!this.$v.user.phone.required)
                errors = errors.concat(this.$t('validations.phone_is_required'))

            return errors
        },

        passwordErrors() {
            let errors = ''

            if (!this.$v.user.password.$dirty) {
                return errors
            }

            if (!this.$v.user.password.required)
                errors = errors.concat(
                    this.$t('validations.password_is_required')
                )

            return errors
        },

        passwordConfirmErrors() {
            let errors = ''

            if (!this.$v.user.passwordConfirm.$dirty) {
                return errors
            }

            if (!this.$v.user.passwordConfirm.required)
                errors = errors.concat(
                    this.$t('validations.password_confirm_is_required')
                )

            if (!this.$v.user.passwordConfirm.sameAsPassword)
                errors = errors.concat(
                    this.$t(
                        'validations.password_confirm_do_not_match_password'
                    )
                )

            return errors
        },

        firstNameErrors() {
            let errors = ''

            if (!this.$v.user.first_name.$dirty) {
                return errors
            }

            if (!this.$v.user.first_name.required)
                errors = errors.concat(this.$t('validations.name_is_required'))

            return errors
        },

        taxNumberErrors() {
            let errors = ''

            if (!this.$v.user.tax_number.$dirty) {
                return errors
            }

            if (!this.$v.user.tax_number.required)
                errors = errors.concat(
                    this.$t('validations.tax_number_is_required')
                )

            return errors
        },

        streetErrors() {
            let errors = ''

            if (!this.$v.user.street.$dirty) {
                return errors
            }

            if (!this.$v.user.street.required)
                errors = errors.concat(
                    this.$t('validations.street_is_required')
                )

            return errors
        },

        cityErrors() {
            let errors = ''

            if (!this.$v.user.city.$dirty) {
                return errors
            }

            if (!this.$v.user.city.required)
                errors = errors.concat(this.$t('validations.city_is_required'))

            return errors
        },

        stateErrors() {
            let errors = ''

            if (!this.$v.user.state.$dirty) {
                return errors
            }

            if (!this.$v.user.state.required)
                errors = errors.concat(this.$t('validations.state_is_required'))

            return errors
        },

        countryErrors() {
            let errors = ''

            if (!this.$v.user.country_id.$dirty) {
                return errors
            }

            if (!this.$v.user.country_id.required) {
                errors = errors.concat(
                    this.$t('validations.country_is_required')
                )
            }

            return errors
        },

        currencyErrors() {
            let errors = ''

            if (!this.$v.selectedCurrency.$dirty) {
                return errors
            }

            if (!this.$v.selectedCurrency.required) {
                errors = errors.concat(
                    this.$t('validations.currency_is_required')
                )
            }

            return errors
        },

        companyTitleErrors() {
            let errors = ''

            if (!this.$v.company.title.$dirty) {
                return errors
            }

            if (!this.$v.company.title.required)
                errors = errors.concat(this.$t('validations.title_is_required'))

            return errors
        },

        companyTaxNumberErrors() {
            let errors = ''

            if (!this.$v.company.tax_number.$dirty) {
                return errors
            }

            if (!this.$v.company.tax_number.required)
                errors = errors.concat(
                    this.$t('validations.tax_number_is_required')
                )

            return errors
        },

        companyPhoneErrors() {
            let errors = ''

            if (!this.$v.company.phone.$dirty) {
                return errors
            }

            if (!this.$v.company.phone.required)
                errors = errors.concat(this.$t('validations.phone_is_required'))

            return errors
        },

        companyEmailErrors() {
            let errors = ''

            if (!this.$v.company.email.$dirty) {
                return errors
            }

            if (!this.$v.company.email.required)
                errors = errors.concat(this.$t('validations.email_is_required'))

            if (!this.$v.company.email.isValidEmail)
                errors = errors.concat(
                    this.$t('validations.email_has_invalid_format')
                )

            return errors
        },

        companyStreetErrors() {
            let errors = ''

            if (!this.$v.company.street.$dirty) {
                return errors
            }

            if (!this.$v.company.street.required)
                errors = errors.concat(
                    this.$t('validations.street_is_required')
                )

            return errors
        },

        companyCityErrors() {
            let errors = ''

            if (!this.$v.company.city.$dirty) {
                return errors
            }

            if (!this.$v.company.city.required)
                errors = errors.concat(this.$t('validations.city_is_required'))

            return errors
        },

        companyStateErrors() {
            let errors = ''

            if (!this.$v.company.state.$dirty) {
                return errors
            }

            if (!this.$v.company.state.required)
                errors = errors.concat(this.$t('validations.state_is_required'))

            return errors
        },

        countryCompanyErrors() {
            let errors = ''

            if (!this.$v.company.country_id.$dirty) {
                return errors
            }

            if (!this.$v.company.country_id.required) {
                errors = errors.concat(
                    this.$t('validations.country_is_required')
                )
            }

            return errors
        },
    },
}
